// Downloads.js
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

const Downloads = () => {
  const navigation = useNavigation();
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDownloads();
  }, []);

  const loadDownloads = async () => {
    try {
      const downloadHistory = await AsyncStorage.getItem('downloadHistory');
      const allBooks = await AsyncStorage.getItem('engineeringBooks');
      
      if (downloadHistory && allBooks) {
        const history = JSON.parse(downloadHistory);
        const books = JSON.parse(allBooks);
        
        // Combine download history with book data
        const combined = history.map(download => {
          const book = books.find(b => b.id === download.id);
          return { ...download, ...book };
        });
        
        setDownloads(combined);
      }
    } catch (error) {
      console.error('Error loading downloads:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color="#1f2937" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Downloads</Text>
        <View style={{ width: 24 }} />
      </View>

      <FlatList
        data={downloads}
        keyExtractor={(item) => `${item.id}-${item.date}`}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.downloadItem}
            onPress={() => navigation.navigate('PDFViewer', { book: item })}
          >
            <View style={styles.downloadIcon}>
              <MaterialCommunityIcons 
                name={item.format === 'pdf' ? 'file-pdf-box' : 
                      item.format === 'epub' ? 'book-open-variant' : 'kindle'} 
                size={24} 
                color={
                  item.format === 'pdf' ? '#ef4444' :
                  item.format === 'epub' ? '#667eea' : '#f59e0b'
                } 
              />
            </View>
            <View style={styles.downloadInfo}>
              <Text style={styles.downloadTitle}>{item.title}</Text>
              <Text style={styles.downloadMeta}>
                {String(item.format ?? '').toUpperCase()} • {item.size} • {new Date(item.date).toLocaleDateString()}
              </Text>
            </View>
            <MaterialCommunityIcons name="chevron-right" size={20} color="#6b7280" />
          </TouchableOpacity>
        )}
        ListEmptyComponent={
          <View style={styles.emptyState}>
            <MaterialCommunityIcons name="download-outline" size={64} color="#d1d5db" />
            <Text style={styles.emptyStateTitle}>No downloads yet</Text>
            <Text style={styles.emptyStateText}>
              Download books to read them offline
            </Text>
          </View>
        }
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  downloadItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  downloadIcon: {
    marginRight: 16,
  },
  downloadInfo: {
    flex: 1,
  },
  downloadTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: 4,
  },
  downloadMeta: {
    fontSize: 12,
    color: '#6b7280',
  },
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
    paddingTop: 100,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateText: {
    fontSize: 16,
    color: '#6b7280',
    textAlign: 'center',
  },
});

export default Downloads;